import { render } from "./fileDropperMultiple.vue?vue&type=template&id=027c7b3c&scoped=true&ts=true"
import script from "./fileDropperMultiple.vue?vue&type=script&lang=ts"
export * from "./fileDropperMultiple.vue?vue&type=script&lang=ts"

import "./fileDropperMultiple.vue?vue&type=style&index=0&id=027c7b3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027c7b3c"]])

export default __exports__